import { Navigate, Route, Routes } from 'react-router-dom';
import { Suspense, useEffect } from 'react';
import { useAuthStore } from '../auth/hooks/useAuthStore';

import ScrollToTop from '../common/components/scroll-top/ScrollTop';
import DashboardRoutes from './DashboardRoutes';
import { ProtectedRoute } from './ProtectedRoute';
import { PublicRoute } from './PublicRoute';
import { AuthRoutes } from './AuthRoutes';
import { Loading } from '../ui';

// Rutas perezosas

const AppRouter = () => {
  const { status, checkAuthToken } = useAuthStore();

  useEffect(() => {
    checkAuthToken();
  }, []);

  if (status === 'checking') {
    return <Loading />;
  }

  return (
    <Suspense fallback={<Loading />}>
      <ScrollToTop />
      <Routes>
        <Route
          path="/auth/*"
          element={
            <PublicRoute isAuthenticated={status}>
              <AuthRoutes />
            </PublicRoute>
          }
        />
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute isAuthenticated={status}>
              <DashboardRoutes />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard/general" />} />
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
